module.exports = __webpack_public_path__ + "static/media/crunchtime-netchef.a0b97dd3.jpg";